import { render, staticRenderFns } from "./ServiceTourisme.vue?vue&type=template&id=61b11554&scoped=true&"
import script from "./ServiceTourisme.vue?vue&type=script&lang=js&"
export * from "./ServiceTourisme.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTourisme.vue?vue&type=style&index=0&id=61b11554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b11554",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow})
